import module from 'finanzas/module.js'
import template from './template.html'

module.config(($stateProvider) => {
  $stateProvider.state('finances.reporteFacturas', {
    url: '/reportefacturas?{start:date}&{end:date}&:estado&:ids_empresas',
    data: {
      title: 'Reporte de Facturas',
    },
    params: {
      ids_empresas: {
        array: true,
      },
    },
    resolve: {
      empresas: (FinanzasReporteFacturas) => FinanzasReporteFacturas.obtenerEmpresasFacturacion(),
      Datos: (FinanzasReporteFacturas, $stateParams) => {
        var start = $stateParams.start,
          end = $stateParams.end,
          ids_empresas = $stateParams.ids_empresas,
          estado = $stateParams.estado

        return start && end && ids_empresas && estado ? FinanzasReporteFacturas.obtenerReporte(start, end, ids_empresas, estado) : undefined
      },
    },
    template,
    controllerAs: '$ctrl',
    controller (empresas, Datos, $stateParams, $moment, $location, $filter, $fileSystem, $file, FinanzasReporteFacturas, FinanzasReporteFacturasExportarXML) {
      var $ctrl = this,
        filter = $filter('filter'),
        hoy = $moment().toDate(),
        antes = $moment().subtract(1, 'months').toDate()

      $ctrl.obtenerInformacion = obtenerInformacion
      $ctrl.filtrar = filtrar
      $ctrl.exportar = exportar
      $ctrl.exportarXML = exportarXML
      $ctrl.$onInit = $onInit

      $onInit()

      function $onInit () {
        $ctrl.empresas = empresas
        $ctrl.data = Datos
        $ctrl.conceptos = undefined
        $ctrl.clientes = undefined
        $ctrl.results = undefined
        $ctrl.comprimiendo = false

        $ctrl.estados = [{
          estado: 'TODAS',
        }, {
          estado: 'ACTIVAS',
        }, {
          estado: 'CANCELADAS',
        }]
        $ctrl.opciones = {
          empresas: $stateParams.ids_empresas || [],
          start: $stateParams.start || antes,
          end: $stateParams.end || hoy,
          estado: $stateParams.estado || 'TODAS',
        }
        if ($ctrl.data) {
          $ctrl.conceptos = filtarConceptos($ctrl.data)
          $ctrl.clientes = filtarClientes($ctrl.data)
        }

        $ctrl.filtro = {
          general: '',
          total: '',
          folio: '',
          conceptos: angular.copy($ctrl.conceptos),
          clientes: angular.copy($ctrl.clientes),
        }

        filtrar()
      }

      function obtenerInformacion () {
        $location.search({
          start: $ctrl.opciones.start.toYMD(),
          end: $ctrl.opciones.end.toYMD(),
          ids_empresas: $ctrl.opciones.empresas,
          estado: $ctrl.opciones.estado,
        })
        if ($ctrl.results) {
          $ctrl.conceptos = filtarConceptos($ctrl.results)
          $ctrl.clientes = filtarClientes($ctrl.results)
        }

      }

      function filtrar () {
        var results = $ctrl.data

        if ($ctrl.filtro.conceptos)
          results = filtarPorConceptos(results)

        if ($ctrl.filtro.clientes)
          results = filtarPorClientes(results)

        if ($ctrl.filtro.general)
          results = filter(results, $ctrl.filtro.general)

        if ($ctrl.filtro.folio)
          results = filter(results, {
            folio: $ctrl.filtro.folio,
          })

        if ($ctrl.filtro.total)
          results = filter(results, {
            total: $ctrl.filtro.total,
          })

        $ctrl.results = results
      }

      function filtarPorClientes (data) {
        return data.filter(function (item) {
          return $ctrl.filtro.clientes.indexOf(item.cliente) >= 0
        })
      }

      function filtarPorConceptos (data) {
        return data.filter(function (item) {
          return $ctrl.filtro.conceptos.indexOf(item.concepto_contable) >= 0
        })
      }

      function filtarClientes (data) {
        return data.reduce(function (prev, next) {
          return prev.concat(prev.indexOf(next.cliente) < 0 ? [next.cliente] : [])
        }, [])
      }

      function filtarConceptos (data) {
        return data.reduce(function (prev, next) {
          return prev.concat(prev.indexOf(next.concepto_contable) < 0 ? [next.concepto_contable] : [])
        }, [])
      }

      function exportar () {
        FinanzasReporteFacturas
          .exportarXLS($ctrl.results, 'Facturas')
      }

      function exportarXML () {
        $ctrl.comprimiendo = true
        var activos = $ctrl.results.filter(function (item) {
          return item.estado === '1'
        }).map(function (elemento) {
          return {
            kardex_id: elemento.kardex_id,
            folio: elemento.folio,
          }
        })

        FinanzasReporteFacturasExportarXML.get(activos)
          .then(function (data) {
            var files = data.filter(function (elemento) {
              return elemento.xml !== ''
            }).map(function (item) {
              return {
                name: item.nombre_archivo + '.xml',
                content: item.xml,
              }
            })

            return $file.zipString(files)
              .then(function (data) {
                $file.saveAs(data, 'Facturas.zip')
              })
              .finally(function () {
                $ctrl.comprimiendo = false
              })

          })
      }
    },
  })
})



// WEBPACK FOOTER //
// ./src/finanzas/_/reporteFacturas/controller.js